import { render, staticRenderFns } from "./addDestructedAsset.vue?vue&type=template&id=19d8ac4c&scoped=true&"
import script from "./addDestructedAsset.vue?vue&type=script&lang=js&"
export * from "./addDestructedAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d8ac4c",
  null
  
)

export default component.exports